import { render, staticRenderFns } from "./SubContractors.vue?vue&type=template&id=b73996b2&scoped=true"
import script from "./SubContractors.vue?vue&type=script&lang=js"
export * from "./SubContractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73996b2",
  null
  
)

export default component.exports